import React, { memo } from 'react';
import { TrackFieldValueByName } from '../utils/TrackFieldValueByName';
import { useFormState } from 'react-final-form';
import { evaluateConditions } from '../utils/evaluateConditions';
import { nestedResolveUseSamePath } from '../utils/nestedResolveUseSamePath';
export var ConditionalField = memo(function (_a) {
    var _b, _c, _d;
    var children = _a.children, conditionalRules = _a.conditionalRules, fieldName = _a.fieldName, conditionalRulesChainOption = _a.conditionalRulesChainOption, associatedVisibilityBasedOnOtherFieldValues = _a.associatedVisibilityBasedOnOtherFieldValues;
    if (associatedVisibilityBasedOnOtherFieldValues) {
        var allvalues = useFormState().values;
        var updatedConditions = nestedResolveUseSamePath((_c = (_b = associatedVisibilityBasedOnOtherFieldValues.conditionalFields) === null || _b === void 0 ? void 0 : _b.conditions) !== null && _c !== void 0 ? _c : [], fieldName);
        var conditionalFields = {
            logicalOperator: (_d = associatedVisibilityBasedOnOtherFieldValues === null || associatedVisibilityBasedOnOtherFieldValues === void 0 ? void 0 : associatedVisibilityBasedOnOtherFieldValues.conditionalFields) === null || _d === void 0 ? void 0 : _d.logicalOperator,
            conditions: updatedConditions,
        };
        var result = evaluateConditions(conditionalFields, allvalues);
        return result ? React.createElement(React.Fragment, null, children) : null;
    }
    else {
        var shouldRenderField = conditionalRules.map(function (condition) {
            var conditionalFieldName = condition.fieldName, comparisonMethod = condition.comparisonMethod, _a = condition.useSamePath, useSamePath = _a === void 0 ? false : _a;
            var value = TrackFieldValueByName(fieldName, conditionalFieldName, useSamePath);
            return comparisonMethod(value);
        });
        if (conditionalRulesChainOption === 'OR') {
            return shouldRenderField.some(function (value) { return value; }) ? (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            React.createElement(React.Fragment, null, children)) : null;
        }
        return shouldRenderField.every(function (value) { return value; }) ? (
        // eslint-disable-next-line react/jsx-no-useless-fragment
        React.createElement(React.Fragment, null, children)) : null;
    }
});
ConditionalField.displayName = 'ConditionalField';
